module.exports = __webpack_public_path__ + "assets/img/medicalCarebg2.40725b9c.png";